import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TripCreationModalComponent } from 'src/app/trip-calculator/components/trip-creation-modal/trip-creation-modal/trip-creation-modal.component';
import { TripCreationModalService } from 'src/app/trip-calculator/services/trip-creation-modal.service';
import { GreentripperPinIconComponent } from 'src/app/shared/components/greentripper-pin-icon/greentripper-pin-icon.component';

@Component({
  selector: 'app-empty-view',
  imports: [
    TripCreationModalComponent,
    TranslocoPipe,
    ButtonModule,
    TooltipModule,
    GreentripperPinIconComponent,
  ],
  templateUrl: './empty-view.component.html',
  styleUrl: './empty-view.component.scss',
  standalone: true,
})
export class EmptyViewComponent {
  tripCreationModalService = inject(TripCreationModalService);
}
